export default __webpack_public_path__ + "static/via-uniswap@2x-d9686cfe3e6540a55a5976d0d09bb7cb.png";